const BedroomIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path d="M2 11.583H18.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.16699 8.33301H16.0837" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M16.0833 8.33333V4H4.16667V8.33333L2 11.5833V14.8333H18.25V11.5833L16.0833 8.33333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2 16.9997V14.833" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.25 16.9997V14.833" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default BedroomIcon;
